/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyInfoRouteImport } from './routes/verifyInfo'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRequestRouteImport } from './routes/resetPasswordRequest'
import { Route as ResetPasswordRouteImport } from './routes/resetPassword'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ReadOnlyRouteImport } from './routes/readOnly'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PreviewPackageRouteImport } from './routes/previewPackage'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.[index]'

const VerifyInfoRoute = VerifyInfoRouteImport.update({
  id: '/verifyInfo',
  path: '/verifyInfo',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRequestRoute = ResetPasswordRequestRouteImport.update({
  id: '/resetPasswordRequest',
  path: '/resetPasswordRequest',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/resetPassword',
  path: '/resetPassword',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadOnlyRoute = ReadOnlyRouteImport.update({
  id: '/readOnly',
  path: '/readOnly',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewPackageRoute = PreviewPackageRouteImport.update({
  id: '/previewPackage',
  path: '/previewPackage',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/index',
  path: '/index',
  getParentRoute: () => DashboardRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/previewPackage': typeof PreviewPackageRoute
  '/privacy': typeof PrivacyRoute
  '/readOnly': typeof ReadOnlyRoute
  '/register': typeof RegisterRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/resetPasswordRequest': typeof ResetPasswordRequestRoute
  '/terms': typeof TermsRoute
  '/verifyInfo': typeof VerifyInfoRoute
  '/dashboard/index': typeof DashboardIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/previewPackage': typeof PreviewPackageRoute
  '/privacy': typeof PrivacyRoute
  '/readOnly': typeof ReadOnlyRoute
  '/register': typeof RegisterRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/resetPasswordRequest': typeof ResetPasswordRequestRoute
  '/terms': typeof TermsRoute
  '/verifyInfo': typeof VerifyInfoRoute
  '/dashboard/index': typeof DashboardIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/previewPackage': typeof PreviewPackageRoute
  '/privacy': typeof PrivacyRoute
  '/readOnly': typeof ReadOnlyRoute
  '/register': typeof RegisterRoute
  '/resetPassword': typeof ResetPasswordRoute
  '/resetPasswordRequest': typeof ResetPasswordRequestRoute
  '/terms': typeof TermsRoute
  '/verifyInfo': typeof VerifyInfoRoute
  '/dashboard/index': typeof DashboardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/previewPackage'
    | '/privacy'
    | '/readOnly'
    | '/register'
    | '/resetPassword'
    | '/resetPasswordRequest'
    | '/terms'
    | '/verifyInfo'
    | '/dashboard/index'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/login'
    | '/previewPackage'
    | '/privacy'
    | '/readOnly'
    | '/register'
    | '/resetPassword'
    | '/resetPasswordRequest'
    | '/terms'
    | '/verifyInfo'
    | '/dashboard/index'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/previewPackage'
    | '/privacy'
    | '/readOnly'
    | '/register'
    | '/resetPassword'
    | '/resetPasswordRequest'
    | '/terms'
    | '/verifyInfo'
    | '/dashboard/index'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
  PreviewPackageRoute: typeof PreviewPackageRoute
  PrivacyRoute: typeof PrivacyRoute
  ReadOnlyRoute: typeof ReadOnlyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ResetPasswordRequestRoute: typeof ResetPasswordRequestRoute
  TermsRoute: typeof TermsRoute
  VerifyInfoRoute: typeof VerifyInfoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verifyInfo': {
      id: '/verifyInfo'
      path: '/verifyInfo'
      fullPath: '/verifyInfo'
      preLoaderRoute: typeof VerifyInfoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resetPasswordRequest': {
      id: '/resetPasswordRequest'
      path: '/resetPasswordRequest'
      fullPath: '/resetPasswordRequest'
      preLoaderRoute: typeof ResetPasswordRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resetPassword': {
      id: '/resetPassword'
      path: '/resetPassword'
      fullPath: '/resetPassword'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/readOnly': {
      id: '/readOnly'
      path: '/readOnly'
      fullPath: '/readOnly'
      preLoaderRoute: typeof ReadOnlyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/previewPackage': {
      id: '/previewPackage'
      path: '/previewPackage'
      fullPath: '/previewPackage'
      preLoaderRoute: typeof PreviewPackageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/index': {
      id: '/dashboard/index'
      path: '/index'
      fullPath: '/dashboard/index'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
  PreviewPackageRoute: PreviewPackageRoute,
  PrivacyRoute: PrivacyRoute,
  ReadOnlyRoute: ReadOnlyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ResetPasswordRequestRoute: ResetPasswordRequestRoute,
  TermsRoute: TermsRoute,
  VerifyInfoRoute: VerifyInfoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
